<template>
  <o-view class="c-sales-view" :has-white-background="true" :no-scroll="true">
    <o-view :padding-bottom="true">
      <o-nav-bar
        title="Cambio-inschrijving"
        :has-back-button="true"
        :has-close-button="true"
        :is-overlay="true"
      />
      <o-message-header
        icon="warning"
        text="Oei... je bent nog een beetje te jong om gebruik te maken van onze dienst"
      />
      <o-section>
        <p>
          Hier uitleg die gebruiker duidelijk maakt waarom hij niet verder kan.
          Dit kan op basis van leeftijd of aantal jaren rijbewijs.
        </p>
      </o-section>
    </o-view>
    <o-pay-button label="Sluiten" />
  </o-view>
</template>

<script>
import OMessageHeader from '@/components/OMessageHeader.vue'
import OPayButton from '@/components/OPayButton.vue'
export default {
  name: 'CambioOnboardingConfirmation',
  components: {
    OMessageHeader,
    OPayButton
  }
}
</script>

<style lang="scss"></style>
